import React, { useContext } from "react";
var ListSizeContext = /*#__PURE__*/React.createContext("m");

var useListSize = function useListSize(size) {
  var sizeFromContext = useContext(ListSizeContext);
  return size || sizeFromContext;
};

export { ListSizeContext, useListSize };